import flatten from 'callbag-flatten';
import lazy from 'callbag-lazy';

var defer = function defer(factory) {
  return flatten(lazy(factory));
};

export default defer;